import React, { FC, HTMLAttributes } from "react";
import { Images } from "../../../@assets/images";
import { ElCriteria, ElCriteriaContent, ElColumn, elGapCriteria, ElImage, elBgWhite, ElActionList, ElFooterContent } from "./criteria.css";
import { Container } from "../../layout";
import { elFlexAlignCenter, elFlexJustifyCenter, elFlexNoWrap } from "../../../@css-style";
import { cx } from "@linaria/core";
import { ElDetails, ElAnchorButton, ElHeadLine } from "../head-title";

interface ICriteriaProps extends HTMLAttributes<HTMLElement> {
  link: string;
}

export const Criteria: FC<ICriteriaProps> = ({ children, ...props }) => {
  return (
    <ElCriteria {...props}>
      <Container className={elGapCriteria}>
        <ElCriteriaContent>
          <ElHeadLine style={{ "--hashTag": `"#EXPLORE PROGRAM"` }}>Kriteria Startup</ElHeadLine>
        </ElCriteriaContent>
        <ElCriteriaContent>
          <ElColumn className={elBgWhite}>
            <ElActionList>
              <h3>MoM Growth</h3>
              <p>Growth in revenue or clients every month shows healthy growth.</p>
            </ElActionList>

            <ElActionList>
              <h3>Startup Readiness Index (SCRIN)</h3>
              <p>This point is intended to see the startup's potential to develop by considering resources and financial projections.</p>
            </ElActionList>
            <ElActionList>
              <h3>Market Shares</h3>
              <p>To determine the position of startups in their competition with similar products or businesses in the market.</p>
            </ElActionList>
            <ElActionList>
              <h3>Founders</h3>
              <p>See how efficient the resource management and leadership style of the head level in the company is</p>
            </ElActionList>
            <ElActionList>
              <h3>Funding Status</h3>
              <p>Has the startup successfully raised funding or is it in the process of getting funding?</p>
            </ElActionList>
          </ElColumn>
          <ElColumn className={elBgWhite}>
            <ElImage src={Images.design.criteria} alt="" />
          </ElColumn>
        </ElCriteriaContent>
        <ElCriteriaContent className={cx(elFlexJustifyCenter, elFlexNoWrap, elFlexAlignCenter)}>
          <ElFooterContent>
            <ElDetails>Sesuai dengan Startup kamu?</ElDetails>
            <ElAnchorButton href={props.link} target="_blank">
              Daftar Disini
            </ElAnchorButton>
          </ElFooterContent>
        </ElCriteriaContent>
      </Container>
    </ElCriteria>
  );
};
